{
  "title": "الزيارة",
  "backToMyVisits": "العودة إلى زياراتي",
  "loading": "جارٍ التحميل…",
  "notYourVisit": "لا يعمل على هذه الزيارة إلا فريقها (أو مدير الخدمة).",
  "errors": {
    "changed": "تغيّرت هذه الزيارة في الأثناء. تظهر الآن أحدث نسخة منها: راجعها وحاول مرة أخرى.",
    "changedRetry": "تغيّرت الزيارة في الأثناء وأُعيد تحميلها. راجع التفاصيل وأنهِ الزيارة مرة أخرى."
  },
  "toast": {
    "started": "بدأت الزيارة.",
    "workBegun": "بدأ العمل.",
    "workSaved": "حُفظ العمل المنجز.",
    "finished": "انتهت الزيارة.",
    "finishedFollowUp": "انتهت الزيارة، وطُلبت زيارة أخرى."
  },
  "cancelled": {
    "title": "أُلغيت هذه الزيارة"
  },
  "header": {
    "follows": "تتابع الزيارة {{visit}} بتاريخ {{date}}",
    "openJob": "فتح أمر الخدمة {{number}}",
    "missed": "فائتة",
    "lead": "قائد الزيارة: {{name}}",
    "officeNotes": "ملاحظات المكتب",
    "reschedule": "إعادة الجدولة",
    "cancel": "إلغاء الزيارة",
    "noLead": "لم يُحدَّد قائد بعد"
  },
  "leftFromLast": {
    "title": "المتبقي من الزيارة السابقة",
    "whyNothing": "سبب عدم تنفيذ العمل",
    "unresolved": "ما زال دون حل",
    "managerNote": "ملاحظة المدير"
  },
  "steps": {
    "label": "خطوات الزيارة",
    "counter": "الخطوة {{n}} من {{total}}:",
    "arrive": "الوصول",
    "work": "العمل",
    "finish": "الإنهاء",
    "allDone": "انتهت الزيارة.",
    "state": {
      "done": "مكتملة",
      "current": "الخطوة الحالية",
      "todo": "لم تبدأ بعد"
    }
  },
  "location": {
    "title": "موقع الخدمة",
    "more": "الموقع وجهة الاتصال",
    "noContact": "لا توجد جهة اتصال مسجلة.",
    "directions": "الاتجاهات",
    "directionsLabel": "الاتجاهات إلى {{site}} (تفتح الخرائط)",
    "call": "اتصال",
    "callLabel": "الاتصال بـ{{name}}"
  },
  "items": {
    "title": "بنود العمل",
    "empty": "لا توجد بنود بعد.",
    "emptyInvite": "أضف ما يحتاجه العمل: الخدمات وقطع الغيار مع أسعارها.",
    "total": "الإجمالي (شامل الضريبة)",
    "agreement": "الإصدار {{sequence}} · {{method}}",
    "approvalTitle": "يلزم موافقة العميل على السعر",
    "approvalBody": "لا يمكن تسجيل العمل على البنود المعلَّمة «يحتاج موافقة السعر» حتى يوافق العميل.",
    "approvalAwaiting": "أُرسل السعر إلى العميل. سجّل ردّه لمتابعة هذا العمل.",
    "add": "إضافة بند",
    "recordAnswer": "تسجيل رد العميل",
    "recordApproval": "تسجيل موافقة السعر",
    "edit": "تعديل {{item}}",
    "agreedIn": "متفق عليه (الإصدار {{sequence}})",
    "noApprovalNeeded": "لا يحتاج موافقة",
    "needsApproval": "يحتاج موافقة السعر",
    "progress": "المنجز {{done}} من {{quantity}}",
    "emptyClosed": "لم تكن هناك بنود في هذه الزيارة."
  },
  "work": {
    "thisVisit": "المنجز في هذه الزيارة",
    "inputLabel": "المنجز في هذه الزيارة: {{item}}",
    "less": "إنقاص واحد: {{item}}",
    "more": "زيادة واحد: {{item}}",
    "allDone": "إنجاز الكل",
    "blocked": "بانتظار موافقة العميل على السعر: سجّلها قبل هذا العمل.",
    "leftAfter": "المتبقي بعد هذه الزيارة: {{n}}",
    "complete": "مُنجز.",
    "doneHere": "أُنجز {{n}} في هذه الزيارة",
    "tooMuch": "الحد الأقصى في هذه الزيارة {{max}}.",
    "belowInvoiced": "لا يقل عن {{min}}: هذه الكمية مفوترة بالفعل.",
    "fixFirst": "صحّح الكميات المعلّمة بالأحمر أولاً.",
    "save": "حفظ العمل"
  },
  "photos": {
    "required": "تشترط شركتك صورة واحدة على الأقل قبل إنهاء الزيارة."
  },
  "report": {
    "title": "تقرير الزيارة",
    "workPerformed": "ما تم إنجازه",
    "more": "حقول التقرير الأخرى",
    "empty": "لم يُكتب شيء في التقرير.",
    "autosave": "يُحفظ تلقائياً",
    "saving": "جارٍ الحفظ…",
    "saved": "تم الحفظ",
    "notSaved": "لم يُحفظ التقرير",
    "retry": "احفظ مجدداً"
  },
  "summary": {
    "title": "ملخص الزيارة",
    "outcome": "النتيجة",
    "note": "ملاحظة",
    "arrived": "الوصول",
    "started": "بدء العمل",
    "finished": "الانتهاء"
  },
  "followUp": {
    "title": "زيارة المتابعة",
    "remains": "ما زال في هذا الأمر عمل متبقٍ. اطلب زيارة متابعة: يوافق عليها مدير الخدمة ويحدد موعدها.",
    "invite": "تحتاج زيارة أخرى لإكمال العمل (قطع غيار، وقت إضافي، تعذّر الدخول)؟ اطلبها.",
    "request": "طلب زيارة متابعة",
    "returned": "أعاده {{name}}",
    "returnedPlain": "أُعيد الطلب مع ملاحظة",
    "openVisit": "فتح زيارة المتابعة",
    "resubmit": "تعديل وإعادة الإرسال",
    "requestTitle": "طلب زيارة متابعة",
    "resubmitTitle": "تعديل الطلب وإعادة إرساله",
    "description": "يوافق مدير الخدمة على الطلب ويحجز موعد الزيارة.",
    "dateHint": "متى يستطيع العميل استقبال الفريق (اختياري).",
    "submit": "إرسال الطلب",
    "resubmitSubmit": "إعادة إرسال الطلب",
    "chooseReason": "اختر السبب.",
    "remainingRequired": "اذكر ما تبقى من العمل.",
    "endBeforeStart": "وقت الانتهاء قبل وقت البدء.",
    "sent": "أُرسل طلب زيارة المتابعة إلى مدير الخدمة.",
    "resent": "أُعيد إرسال الطلب.",
    "bookedAtOnce": "تُحجز الزيارة لفريقك فورًا: في التاريخ المقترح، وإلا في يوم العمل التالي.",
    "bookSubmit": "حجز الزيارة",
    "booked": "حُجزت زيارة المتابعة. افتحها من هذه الزيارة.",
    "remainsAtOnce": "ما زال هناك عمل في هذا الأمر. احجز زيارة أخرى لفريقك."
  },
  "rest": {
    "title": "ما تبقّى من الأمر",
    "visitDone_zero": "لا معدّات في هذه الزيارة.",
    "visitDone_one": "فُحصت المعدّة الوحيدة في هذه الزيارة.",
    "visitDone_two": "فُحصت المعدّتان في هذه الزيارة.",
    "visitDone_few": "فُحصت كل المعدّات الـ{{n}} في هذه الزيارة.",
    "visitDone_many": "فُحصت كل المعدّات الـ{{n}} في هذه الزيارة.",
    "visitDone_other": "فُحصت كل المعدّات الـ{{n}} في هذه الزيارة.",
    "visitPart": "فُحصت {{checked}} من {{total}} معدّة في هذه الزيارة.",
    "job": "يشمل الأمر {{total}} معدّة: فُحص منها {{checked}}، وبقي {{left}} للفحص.",
    "where": "بقي للفحص",
    "why": "لهذا انتهت الزيارة بإنجاز جزئي: يكتمل الأمر حين تُفحص كل معدّاته.",
    "book": "احجز الباقي",
    "office": "يحجز المكتب زيارة لبقية الأمر."
  },
  "money": {
    "title": "الفواتير والمدفوعات",
    "contract": "مشمول بعقد خدمة: لا تصدر فاتورة من هذه الزيارة.",
    "invoices": "الفواتير",
    "noInvoices": "لم يُفوتر شيء بعد.",
    "balance": "الرصيد",
    "collections": "المبالغ المحصلة",
    "invoice": "فوترة العمل المنجز",
    "collect": "تسجيل مبلغ محصل"
  },
  "action": {
    "start": "ابدأ الزيارة",
    "startHint": "اضغط عند وصولك إلى الموقع.",
    "beginWork": "ابدأ العمل",
    "beginWorkHint": "أنت في الموقع. ابدأ العمل لتسجيل ما تنجزه.",
    "finish": "أنهِ الزيارة",
    "unsavedWork": "تُحفظ الكميات التي غيّرتها عند إنهاء الزيارة.",
    "followUp": "طلب زيارة متابعة",
    "invoice": "فوترة العمل المنجز",
    "collect": "تسجيل مبلغ محصل",
    "nextVisit": "الزيارة التالية",
    "nextVisitHint": "التالية لفريقك اليوم: {{customer}} · {{place}}"
  },
  "finish": {
    "title": "إنهاء الزيارة {{visit}}",
    "description": "بعد إنهائها تبقى الزيارة كما جرت.",
    "outcome": "كيف سارت الزيارة؟",
    "allDone": "اكتمل العمل",
    "comeBack": "نحتاج إلى العودة",
    "couldNot": "تعذّر إنجاز العمل",
    "fullHint": "يُسجَّل كل ما تبقى من العمل منجزاً.",
    "fullBlocked": "«{{item}}» ما زال يحتاج موافقة العميل على السعر.",
    "partialHint": "أُنجز جزء من العمل، والباقي يحتاج زيارة أخرى.",
    "noneHint": "لم يُنجز أي عمل في هذه الزيارة.",
    "noneBlocked": "يوجد عمل مسجل في هذه الزيارة: اختر «نحتاج إلى العودة».",
    "chooseOutcome": "اختر كيف سارت الزيارة.",
    "why": "لماذا تعذّر إنجاز العمل؟",
    "whyRequired": "اذكر سبب تعذّر إنجاز العمل.",
    "whyPick": "ماذا حدث؟",
    "whyReason": {
      "CUSTOMER_UNAVAILABLE": "لا أحد في الموقع",
      "ACCESS_PROBLEM": "تعذّر الدخول",
      "PARTS_NEEDED": "تلزم قطع غيار أو أدوات",
      "OTHER": "سبب آخر"
    },
    "whySentence": {
      "CUSTOMER_UNAVAILABLE": "لم يكن أحد في الموقع ليسمح لنا بالدخول.",
      "ACCESS_PROBLEM": "تعذّر علينا الوصول إلى الموقع أو المعدّات.",
      "PARTS_NEEDED": "احتجنا إلى قطع غيار أو أدوات لم تكن معنا."
    },
    "waitingParts": "سيظهر أمر الخدمة بانتظار قطع الغيار حتى تبدأ الزيارة التالية.",
    "waitingCustomer": "سيظهر أمر الخدمة بانتظار العميل حتى تبدأ الزيارة التالية.",
    "left": "ما تبقى من العمل",
    "leftRequired": "اذكر ما تبقى من العمل.",
    "askAgain": "طلب زيارة أخرى",
    "reason": "سبب الزيارة الأخرى",
    "nextDate": "التاريخ المفضّل",
    "signOff": "إقرار العميل",
    "optional": "اختياري",
    "ackName": "اسم العميل",
    "ackHint": "العميل الذي اطّلع على العمل.",
    "ackRequired": "أدخل اسم العميل الذي أقرّ بالزيارة.",
    "photoRequired": "أضف صورة واحدة على الأقل للعمل قبل الإنهاء.",
    "submit": "أنهِ الزيارة",
    "leftPlanned_zero": "لا معدّات متبقية للفحص",
    "leftPlanned_one": "معدّة واحدة متبقية للفحص",
    "leftPlanned_two": "معدّتان متبقيتان للفحص",
    "leftPlanned_few": "{{n}} معدّات متبقية للفحص",
    "leftPlanned_many": "{{n}} معدّة متبقية للفحص",
    "leftPlanned_other": "{{n}} معدّة متبقية للفحص",
    "leftPlace": "{{place}}: {{assets}}",
    "placeAssets_zero": "لا معدّات",
    "placeAssets_one": "معدّة واحدة",
    "placeAssets_two": "معدّتان",
    "placeAssets_few": "{{n}} معدّات",
    "placeAssets_many": "{{n}} معدّة",
    "placeAssets_other": "{{n}} معدّة",
    "fullChecked": "فُحصت كل معدّات الأمر.",
    "fullChecksLeft_zero": "فُحصت كل معدّات الأمر.",
    "fullChecksLeft_one": "لم تُفحص بعد معدّة واحدة: لا يمكن إنهاء الأمر كاملاً.",
    "fullChecksLeft_two": "لم تُفحص بعد معدّتان: لا يمكن إنهاء الأمر كاملاً.",
    "fullChecksLeft_few": "لم تُفحص بعد {{n}} معدّات: لا يمكن إنهاء الأمر كاملاً.",
    "fullChecksLeft_many": "لم تُفحص بعد {{n}} معدّة: لا يمكن إنهاء الأمر كاملاً.",
    "fullChecksLeft_other": "لم تُفحص بعد {{n}} معدّة: لا يمكن إنهاء الأمر كاملاً.",
    "partialChecksLeft_zero": "لا يبقى شيء للزيارة التالية.",
    "partialChecksLeft_one": "تبقى معدّة واحدة للزيارة التالية.",
    "partialChecksLeft_two": "تبقى معدّتان للزيارة التالية.",
    "partialChecksLeft_few": "تبقى {{n}} معدّات للزيارة التالية.",
    "partialChecksLeft_many": "تبقى {{n}} معدّة للزيارة التالية.",
    "partialChecksLeft_other": "تبقى {{n}} معدّة للزيارة التالية.",
    "checksWaiting_zero": "لا فحوص بانتظار الإرسال.",
    "checksWaiting_one": "ما زال فحص واحد بانتظار الإرسال. أرسله (إعادة المحاولة في قائمة الفحص) قبل الإنهاء.",
    "checksWaiting_two": "ما زال فحصان بانتظار الإرسال. أرسلهما (إعادة المحاولة في قائمة الفحص) قبل الإنهاء.",
    "checksWaiting_few": "ما زالت {{n}} فحوص بانتظار الإرسال. أرسلها (إعادة المحاولة في قائمة الفحص) قبل الإنهاء.",
    "checksWaiting_many": "ما زال {{n}} فحصاً بانتظار الإرسال. أرسلها (إعادة المحاولة في قائمة الفحص) قبل الإنهاء.",
    "checksWaiting_other": "ما زال {{n}} فحص بانتظار الإرسال. أرسلها (إعادة المحاولة في قائمة الفحص) قبل الإنهاء.",
    "checksIncomplete_zero": "فُحصت كل معدّات هذا الأمر الوقائي.",
    "checksIncomplete_one": "لم تُفحص بعد معدّة واحدة من هذا الأمر الوقائي. افحصها أو اختر «نحتاج إلى العودة».",
    "checksIncomplete_two": "لم تُفحص بعد معدّتان من هذا الأمر الوقائي. افحصهما أو اختر «نحتاج إلى العودة».",
    "checksIncomplete_few": "لم تُفحص بعد {{n}} معدّات من هذا الأمر الوقائي. افحصها أو اختر «نحتاج إلى العودة».",
    "checksIncomplete_many": "لم تُفحص بعد {{n}} معدّة من هذا الأمر الوقائي. افحصها أو اختر «نحتاج إلى العودة».",
    "checksIncomplete_other": "لم تُفحص بعد {{n}} معدّة من هذا الأمر الوقائي. افحصها أو اختر «نحتاج إلى العودة».",
    "checksIncompleteUnknown": "لم تُفحص بعد كل معدّات هذا الأمر الوقائي. افحصها أو اختر «نحتاج إلى العودة».",
    "bookAgain": "حجز زيارة أخرى",
    "markRest_one": "تعليم المعدّة غير المفحوصة الوحيدة كمنجزة والإنهاء",
    "markRest_other": "تعليم المعدّات غير المفحوصة ({{n}}) كمنجزة والإنهاء",
    "markRestHint": "فقط إذا فُحصت كل معدّة فعلًا: تُسجَّل كل واحدة كمنجزة باسمك.",
    "markRestRequired": "علّم الخيار للإنهاء بالكامل، أو اختر «يلزم العودة».",
    "markRest_zero": "لا معدّات غير مفحوصة: الإنهاء",
    "markRest_two": "تعليم المعدّتين غير المفحوصتين كمنجزتين والإنهاء",
    "markRest_few": "تعليم المعدّات غير المفحوصة ({{n}}) كمنجزة والإنهاء",
    "markRest_many": "تعليم المعدّات غير المفحوصة ({{n}}) كمنجزة والإنهاء"
  },
  "invoice": {
    "title": "فوترة العمل المنجز",
    "description": "فاتورة واحدة لأمر الخدمة {{job}} تُرحَّل في المبيعات.",
    "hint": "تبدأ كل كمية بما أُنجز ولم يُفوتر بعد. اكتب 0 لاستبعاد البند.",
    "ready": "جاهز للفوترة: {{n}}",
    "quantity": "الكمية المراد فوترتها: {{item}}",
    "atMost": "الحد الأقصى {{n}}.",
    "total": "إجمالي الفاتورة",
    "posts": "تُرحَّل الفاتورة فوراً: تُقيَّد الإيرادات وضريبة القيمة المضافة في الدفاتر.",
    "submit": "ترحيل الفاتورة",
    "nothing": "لا يوجد عمل منجز متبقٍ للفوترة.",
    "tooMuch": "بعض الكميات أكثر من الجاهز للفوترة.",
    "chooseOne": "أدخل كمية لبند واحد على الأقل.",
    "doneTitle": "رُحّلت الفاتورة",
    "posted": "الفاتورة المرحّلة",
    "already": "فُوتر سابقاً بالفاتورة",
    "nextStep": "عندما يدفع العميل، سجّل المبلغ المحصل.",
    "open": "فتح الفاتورة {{number}}",
    "recordPayment": "تسجيل تحصيل",
    "close": "تم",
    "paidNow": "هل دفع العميل الآن؟",
    "paidNowNo": "ليس الآن",
    "paidNowCash": "نقدًا",
    "paidNowCard": "بطاقة",
    "paidNowHint": "تُسجَّل الدفعة بكامل الإجمالي وبتاريخ اليوم، وتنتظر تحقق المحاسب.",
    "submitPaid": "ترحيل وتسجيل الدفعة",
    "paidToast": "رُحّلت الفاتورة {{number}} وسُجّلت الدفعة",
    "paidFailed": "رُحّلت الفاتورة، لكن الدفعة لم تُسجَّل. سجّلها هنا."
  },
  "collection": {
    "title": "تسجيل مبلغ محصل",
    "verifyNote": "لا يتغير رصيد الفاتورة إلا بعد أن يتحقق المحاسب من هذا المبلغ.",
    "loadingInvoice": "جارٍ تحميل الفاتورة المرحّلة للتو…",
    "invoice": "الفاتورة",
    "open": "المفتوح:",
    "reported": "بانتظار التحقق:",
    "amount": "المبلغ المستلم",
    "method": "طريقة الدفع",
    "collectedOn": "تاريخ الاستلام",
    "reference": "المرجع",
    "referenceHint": "رقم الشيك أو مرجع التحويل.",
    "notes": "ملاحظات",
    "submit": "تسجيل المبلغ",
    "nothing": "لا توجد فاتورة مرحّلة لهذا الأمر عليها رصيد للتحصيل.",
    "chooseInvoice": "اختر الفاتورة التي دفعها العميل.",
    "amountRequired": "أدخل مبلغاً أكبر من صفر.",
    "tooMuch": "هذا أكثر من المفتوح على الفاتورة ({{open}}).",
    "dateRequired": "أدخل تاريخ استلام المبلغ.",
    "toast": "سُجّل المبلغ المحصل على {{number}}",
    "addPhoto": "أضف صورة",
    "doneTitle": "سُجّل المبلغ المحصل",
    "recorded": "سُجّل على الفاتورة",
    "awaiting": "بانتظار تحقق المحاسب؛ يتغير رصيد الفاتورة بعد التحقق.",
    "evidenceHint": "أضف صورة للإيصال أو لإشعار التحويل.",
    "close": "تم"
  },
  "myVisits": {
    "title": "زياراتي",
    "intro": "زيارات فرقك لهذا اليوم.",
    "day": "اليوم المعروض",
    "today": "اليوم",
    "previous": "السابق",
    "next": "التالي",
    "previousDay": "اليوم السابق",
    "nextDay": "اليوم التالي",
    "emptyToday": "لا زيارات لفرقك اليوم.",
    "empty": "لا زيارات لفرقك في هذا اليوم.",
    "emptyHint": "تظهر هنا الزيارات التي يحجزها المكتب لفرقك.",
    "goToday": "الانتقال إلى اليوم",
    "listLabel": "الزيارات",
    "missed": "فائتة",
    "earlierTitle": "من أيام سابقة، لم تُنجز بعد",
    "earlierFailed": "تعذّر تحميل الزيارات التي بقيت مفتوحة من أيام سابقة.",
    "todayTitle": "زيارات اليوم",
    "count_zero": "لا زيارات",
    "count_one": "زيارة واحدة · المنتهية {{done}}",
    "count_two": "زيارتان · المنتهية {{done}}",
    "count_few": "{{n}} زيارات · المنتهية {{done}}",
    "count_many": "{{n}} زيارة · المنتهية {{done}}",
    "count_other": "{{n}} زيارة · المنتهية {{done}}",
    "countToday_zero": "اليوم: لا زيارات",
    "countToday_one": "اليوم: زيارة واحدة · المنتهية {{done}}",
    "countToday_two": "اليوم: زيارتان · المنتهية {{done}}",
    "countToday_few": "اليوم: {{n}} زيارات · المنتهية {{done}}",
    "countToday_many": "اليوم: {{n}} زيارة · المنتهية {{done}}",
    "countToday_other": "اليوم: {{n}} زيارة · المنتهية {{done}}",
    "dayHeading": "{{weekday}}، {{date}}",
    "nextVisit": "الزيارة التالية: {{date}}",
    "noneAhead": "ولا زيارات لفرقك في الأيام الـ{{n}} القادمة.",
    "callLabel": "الاتصال بـ{{name}}، {{customer}}"
  },
  "leave": {
    "title": "تجاهل التغييرات غير المحفوظة؟",
    "body": "الكميات التي غيّرتها في هذه الزيارة لم تُحفظ بعد.",
    "reportBody": "تعذّر حفظ آخر التغييرات على تقرير الزيارة.",
    "confirm": "تجاهل التغييرات",
    "stay": "متابعة التعديل"
  },
  "checklist": {
    "title": "قائمة فحص المعدّات",
    "assets_zero": "لا معدّات في هذه الزيارة",
    "assets_one": "معدّة واحدة في هذه الزيارة",
    "assets_two": "معدّتان في هذه الزيارة",
    "assets_few": "{{n}} معدّات في هذه الزيارة",
    "assets_many": "{{n}} معدّة في هذه الزيارة",
    "assets_other": "{{n}} معدّة في هذه الزيارة",
    "beforeStart": "تُسجَّل الفحوص بعد بدء الزيارة.",
    "readOnly": "الفحوص المسجَّلة في هذه الزيارة.",
    "empty": "لا معدّات في هذا العرض.",
    "announce": "{{tag}}: {{outcome}}",
    "progress": {
      "label": "تقدّم الفحص",
      "visit": "فُحصت {{checked}} من {{total}}",
      "job": "الأمر: فُحصت {{checked}} من {{total}} في كل زياراته"
    },
    "saves": {
      "waiting_zero": "لا فحوص بانتظار الإرسال",
      "waiting_one": "فحص واحد بانتظار الإرسال",
      "waiting_two": "فحصان بانتظار الإرسال",
      "waiting_few": "{{n}} فحوص بانتظار الإرسال",
      "waiting_many": "{{n}} فحصاً بانتظار الإرسال",
      "waiting_other": "{{n}} فحص بانتظار الإرسال",
      "retry": "إعادة المحاولة",
      "sending": "جارٍ الحفظ",
      "saved": "حُفظ",
      "held": "بالانتظار",
      "notSaved": "لم يُحفظ",
      "refused": "لم يُحفظ: {{message}}",
      "dismiss": "إخفاء"
    },
    "search": {
      "label": "البحث عن معدّة",
      "placeholder": "ابحث برقم الملصق أو الموضع أو المكان",
      "none": "لا معدّة تطابق «{{q}}»."
    },
    "chips": {
      "label": "الأماكن",
      "all": "الكل",
      "countLabel": "فُحص",
      "name": "{{place}}، فُحصت {{checked}} من {{total}}"
    },
    "outcome": {
      "DONE": "تم",
      "ISSUE": "عطل",
      "NO_ACCESS": "تعذّر الوصول",
      "SKIPPED": "تُخطّي",
      "label": "{{outcome}}: {{tag}}"
    },
    "row": {
      "more": "المزيد لـ {{tag}}",
      "skip": "تخطٍّ مع ذكر السبب",
      "open": "إظهار قائمة فحصها",
      "close": "إخفاء قائمة فحصها",
      "notInVisit": "ليست في أماكن هذه الزيارة",
      "earlier": "فُحصت في {{date}}",
      "outOfOrder": "معطّلة",
      "chooseOutcome": "اختر «تم» أو «عطل» أو «تعذّر الوصول» للحفظ."
    },
    "group": {
      "count": "فُحصت {{checked}} من {{total}}",
      "allDone": "تم فحص الكل في {{place}}",
      "allDoneLabel_zero": "لا معدّات غير مفحوصة في {{place}}",
      "allDoneLabel_one": "تعليم المعدّة غير المفحوصة في {{place}} بأنها تمت",
      "allDoneLabel_two": "تعليم المعدّتين غير المفحوصتين في {{place}} بأنهما تمتا",
      "allDoneLabel_few": "تعليم {{n}} معدّات غير مفحوصة في {{place}} بأنها تمت",
      "allDoneLabel_many": "تعليم {{n}} معدّة غير مفحوصة في {{place}} بأنها تمت",
      "allDoneLabel_other": "تعليم {{n}} معدّة غير مفحوصة في {{place}} بأنها تمت",
      "confirm_zero": "لا شيء لتعليمه",
      "confirm_one": "تعليم واحدة بأنها تمت",
      "confirm_two": "تعليم اثنتين بأنهما تمتا",
      "confirm_few": "تعليم {{n}} بأنها تمت",
      "confirm_many": "تعليم {{n}} بأنها تمت",
      "confirm_other": "تعليم {{n}} بأنها تمت",
      "cancel": "إلغاء",
      "announce_zero": "لم تُعلَّم معدّات في {{place}}",
      "announce_one": "عُلّمت معدّة واحدة في {{place}} بأنها تمت",
      "announce_two": "عُلّمت معدّتان في {{place}} بأنهما تمتا",
      "announce_few": "عُلّمت {{n}} معدّات في {{place}} بأنها تمت",
      "announce_many": "عُلّمت {{n}} معدّة في {{place}} بأنها تمت",
      "announce_other": "عُلّمت {{n}} معدّة في {{place}} بأنها تمت"
    },
    "rest": {
      "show": "إظهار بقية معدّات الأمر ({{n}})",
      "hide": "إخفاء بقية معدّات الأمر"
    },
    "items": {
      "title": "قائمة الفحص",
      "yes": "تم",
      "no": "لم يتم",
      "readingLabel": "{{label}} ({{unit}})",
      "invalid": "أدخل رقماً: حتى 9 أرقام و3 منازل عشرية.",
      "none": "لا بنود فحص لهذه المعدّة.",
      "noneRecorded": "لم يُسجَّل شيء في قائمة الفحص.",
      "notChecked": "لم تُفحص في هذه الزيارة."
    },
    "note": {
      "label": "ملاحظة"
    },
    "issue": {
      "label": "ما العطل؟",
      "required": "صِف العطل."
    },
    "reason": {
      "label": "لماذا؟",
      "required": "اذكر السبب.",
      "common": "أسباب شائعة",
      "tenantAway": "الساكن غير موجود",
      "locked": "مقفل",
      "unsafe": "الوصول إليها غير آمن",
      "noKey": "لا يوجد مفتاح",
      "notNeeded": "غير مطلوبة هذه المرة",
      "customerAsked": "طلب العميل تخطيها",
      "switchedOff": "أطفأها العميل",
      "removed": "أُزيلت من الموقع"
    },
    "save": {
      "ISSUE": "حفظ العطل",
      "NO_ACCESS": "حفظ: تعذّر الوصول",
      "SKIPPED": "حفظ: تُخطّيت",
      "cancel": "إلغاء"
    },
    "fault": {
      "open": "فتح أمر عطل",
      "hint": "أمر جديد على هذه المعدّة يجدوله المكتب.",
      "waitForSave": "يمكن فتح أمر العطل بعد حفظ العطل.",
      "opened": "فُتح أمر العطل {{number}}.",
      "link": "أمر العطل {{number}}",
      "linkShort": "أمر العطل {{number}}"
    },
    "photos": {
      "afterSave": "يمكن إضافة الصور بعد حفظ الفحص."
    }
  }
}
